export const ListQueryKey = 'encodingConfigs';
export const DetailQueryKey = 'encodingConfig';

export const Urls = {
  selectUrl: '/EncodingConfig/list',
  updateUrl: '/EncodingConfig/update',
  deleteUrl: '/EncodingConfig/delete',
  createUrl: '/EncodingConfig/create',
  detailUrl: '/EncodingConfig/detail',
};
